import styled from "styled-components";

const MultiSelectSubmit = styled.button`
    background: #3f51b5;
    padding: 12px;
    color: #ffffff;
    border: 1px #ffffff solid;
    border-radius: 8px;
    width: 100%
    font-size: 14px;
    position: sticky;
    bottom: 0;
`

export default MultiSelectSubmit;